import React, {
  useRef,
  useEffect,
  useState,
  useCallback,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import { getInitFormData } from "@shared/utils/CommonUtils";
import { global, globalMenu } from "@shared/libs/Global";
import SnForm, { ValueChangedEvent } from "@widgets/SnForm";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SearchPanel from "@widgets/SearchPanel";
import { menuInfo } from "@shared/type/CommonType";
import { showDialog } from "src/widgets/CommonDialog";
import SnTab from "@shared/components/SnTab";
import SnButton from "@shared/components/SnButton";
import SnTabHeader from "@shared/components/SnTabHeader";
import SnFileHelper from "@shared/components/SnFileHelper";
import SnResizeBar from "@shared/components/SnResizeBar";
import ExcelUpload from "@widgets/commonpopup/ExcelUpload";
import { showPopupModal, showResizablePopupModal } from "@widgets/CommonModal";
import SN_MAS_BAS_REG_001_POP_001 from "@menu/MAS/SN_MAS_BAS_REG_001/SN_MAS_BAS_REG_001_POP_001";
import SN_MAS_BAS_REG_001_POP_002 from "@menu/MAS/SN_MAS_BAS_REG_001/SN_MAS_BAS_REG_001_POP_002";
import SN_MAS_BAS_REG_001_POP_003 from "@menu/MAS/SN_MAS_BAS_REG_001/SN_MAS_BAS_REG_001_POP_003";

import { callApi, fnGetDataSet, fnSave } from "@shared/api/restApi";

interface Props {
  Menuprops: menuInfo;
}

// 거래처등록
const SN_MAS_BAS_REG_001 = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo, config } = global();

  const searchRef = useRef<any>(null);
  const sharedFormRef1 = useRef<any>(null);
  const sharedFormRef2 = useRef<any>(null);
  const fileHelperRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
    grid3: React.createRef(),
    sheet1: React.createRef(),
  });

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [sharedForm1, setSharedForm1] = useState<any[]>([]);
  const [sharedForm2, setSharedForm2] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
    sheet1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
    sheet1: [],
  });

  const [isVisible, setIsVisible] = useState<boolean>(true);
  const selectedTabPage = useRef<string>("1");

  const [focusedRowData, setFocusedRowData] = useState<any>();
  const [focusedRowData2, setFocusedRowData2] = useState<any>();

  // 파일첨부 진행 정보(대상 행, 기존 파일명, 저장 경로). 업로드 성공 콜백에서 사용
  const pendingAttachRef = useRef<{
    node: any;
    prevFile: string;
    customPath: string;
  } | null>(null);

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({ etcInfo: {} });
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        setSharedForm1(rtn.form.freeform1);
        setSharedForm2(rtn.form.freeform3);

        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
          grid3: rtn.grid.grid3,
          sheet1: rtn.grid.sheet1,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
    onExcelUpload,
    onExcelDownLoad,
  }));

  const onSearch = async () => {
    const modifiedRows = gridRefs.current["grid1"].current?.getChange();
    const modifiedRows2 = gridRefs.current["grid2"].current?.getChange();
    const modifiedRows3 = gridRefs.current["grid3"].current?.getChange();

    if (
      modifiedRows?.modifiedRowcount > 0 ||
      modifiedRows2?.modifiedRowcount > 0 ||
      modifiedRows3?.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirmCancel",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );

      if (confirm) {
        await onSave();
      } else if (confirm === undefined) {
        return;
      }
    }

    try {
      const p = {
        ...searchRef.current.getFormdata(),
        g_cd_firm: userInfo.cd_firm,
        g_cd_cust: userInfo.cd_cust || "",
      };
      const params = {
        id: "sn_mas_bas_reg_001_01",
        params: p,
      };

      setFocusedRowData(null);
      setFocusedRowData2(null);

      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0] || [],
        grid2: data[1] || [],
        grid3: data[2] || [],
        sheet1: data[2] || [],
      });

      gridRefs.current["grid1"].current?.resetUpdate();
      gridRefs.current["grid2"].current?.resetUpdate();
      gridRefs.current["grid3"].current?.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onExcelUpload = async () => {
    try {
      const component = (
        <ExcelUpload
          Menuprops={Menuprops} // 메뉴 정보 전달
          PkFields={["cd_cust"]} // PK 필드 목록 전달
          tableName="mas_cust" // 저장할 테이블 이름
          controllerName="SN_MAS_BAS_REG_001_SAVE_01" // 저장할 컨트롤러 이름
          // userInfo={userInfo}
        />
      );

      const result = await showPopupModal({
        title: "엑셀 업로드",
        children: component,
        width: "80%",
        height: "90VH",
        okayBtnText: "저장",
      });

      if (result?.excelUpload) {
        await onSearch();
      }

      if (result) {
        console.log("엑셀 업로드 완료:", result);
      } else {
        console.log("엑셀 업로드 취소됨");
      }
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onExcelDownLoad = async () => {
    try {
      const rows: any[] = [];
      gridRefs.current["grid1"].current?.forEachFilteredNode((node: any) => {
        if (node?.data) rows.push(node.data);
      });

      gridRefs.current["sheet1"].current?.deleteAllRows?.();
      gridRefs.current["sheet1"].current?.applyTransaction({
        add: rows.map((r) => ({ ...r })),
      });

      const displayedCols =
        gridRefs.current["sheet1"].current?.getAllDisplayedColumns() || [];
      const columnKeys = displayedCols.map((c: any) => c.getColId());

      gridRefs.current["sheet1"].current?.exportDataAsExcel({
        columnKeys,
        skipPinnedBottom: true,
        fileName: `${globalMenu.getState().activeMenuInfo.nm_menu}.xlsx`,
        sheetName: "Sheet1",
      });
    } catch (e: any) {
      showDialog("error", e?.message || "Excel 다운로드 오류");
    }
  };

  const onInsert = () => {
    if (selectedTabPage.current === "1") {
      gridRefs.current["grid1"].current.addRow();
    } else {
      gridRefs.current["grid2"].current.addRow();
    }
  };

  const onDeleteRow = async () => {
    try {
      gridRefs.current["grid3"].current?.deleteSelectedRows();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onAddRow = async () => {
    try {
      if (!gridRefs.current["grid1"].current?.getDisplayedRowCount()) {
        return;
      }

      gridRefs.current["grid1"].current?.stopEditing();
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedNodeH == null) {
        showDialog("alert", "선택된 행이 없습니다.");
        return false;
      }

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return false;
      }

      gridRefs.current["grid3"].current?.applyFilters({
        cd_cust: focusedNodeH.data?.cd_cust,
      });

      gridRefs.current["grid3"].current?.addRow();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onDelete = async () => {
    if (selectedTabPage.current === "1") {
      const confirm = await showDialog("confirm", "삭제하시겠습니까?");

      if (!confirm) {
        return; // 사용자가 아니오를 선택하면 함수 종료
      }

      gridRefs.current["grid1"].current?.deleteSelectedRows();
    } else {
      const confirm = await showDialog("confirm", "삭제하시겠습니까?");

      if (!confirm) {
        return; // 사용자가 아니오를 선택하면 함수 종료
      }

      gridRefs.current["grid2"].current?.deleteSelectedRows();
    }
  };

  const onGrid1BtnClick = async (id: string) => {
    if (id !== "btnImport") return;

    try {
      // 프록시 거래처 목록을 팝업에 띄우고, 체크한 건만 mas_cust에 저장한다.
      // 저장은 팝업의 checkValidity에서 처리하므로 여기서는 결과만 보고 재조회한다.
      const component = <SN_MAS_BAS_REG_001_POP_003 />;
      const result = await showResizablePopupModal({
        title: "거래처정보 가져오기",
        children: component,
        width: "1200px",
        height: "600px",
        validation: true,
      });
      if (Array.isArray(result) && result.flat().length > 0) await onSearch();
    } catch (error: any) {}
  };

  const onGrid2BtnClick = async (id: string) => {
    if (id == "btnDeposit1") {
      const focusedRowNode =
        gridRefs.current["grid1"]?.current?.focusedRowNode();
      if (!focusedRowNode) {
        await showDialog("alter", "행을 선택하세요.");
        return;
      }

      const selectedData = {
        nm_biz: userInfo?.nm_biz,
        cd_cust: focusedRowNode.data.cd_cust,
        nm_cust_sort: focusedRowNode.data.nm_cust_sort,
      };

      const component = (
        <SN_MAS_BAS_REG_001_POP_001 selectedData={selectedData} />
      );
      const result = await showResizablePopupModal({
        title: "계좌번호 등록",
        children: component,
        width: "1100px",
        height: "450px",
        validation: true,
      });
    }
    if (id == "btnDeposit2") {
      const focusedRowNode =
        gridRefs.current["grid2"]?.current?.focusedRowNode();
      if (!focusedRowNode) {
        await showDialog("alter", "행을 선택하세요.");
        return;
      }

      const selectedData = {
        nm_biz: userInfo?.nm_biz,
        cd_cust: focusedRowNode.data.cd_cust,
        nm_cust_sort: focusedRowNode.data.nm_cust_sort,
        fg_account: focusedRowNode.data.fg_account,
      };

      const component = (
        <SN_MAS_BAS_REG_001_POP_002 selectedData={selectedData} />
      );
      const result = await showResizablePopupModal({
        title: "계좌번호 등록",
        children: component,
        width: "1100px",
        height: "450px",
        validation: true,
      });
    }
  };

  const onGrid3BtnClick = async (id: string) => {
    if (id == "addRow") {
      onAddRow();
      return;
    }

    let focusedRowNode = gridRefs.current["grid3"]?.current?.focusedRowNode();
    if (focusedRowNode?.data) {
      const g3 = gridRefs.current["grid3"].current;
      const byKey = focusedRowNode.data.KeyField
        ? g3.getRowNode(focusedRowNode.data.KeyField)
        : null;
      if (byKey) {
        focusedRowNode = byKey;
      } else {
        let found: any = null;
        g3.forEachFilteredNode((n: any) => {
          if (
            !found &&
            n.data?.cd_cust === focusedRowNode.data.cd_cust &&
            String(n.data?.no_line) === String(focusedRowNode.data.no_line)
          ) {
            found = n;
          }
        });
        focusedRowNode = found;
      }
    }
    if (!focusedRowNode) {
      await showDialog("alter", "첨부파일 행을 선택하세요.");
      return;
    }
    focusedRowNode.setSelected?.(true, true);

    const customPath = `${Menuprops.cd_module}/CUST/${focusedRowNode.data.cd_cust}/`;

    if (id == "deleteRow") {
      const nmFile = focusedRowNode.data.nm_file;
      onDeleteRow();
      if (nmFile) {
        await fileHelperRef.current?.deleteFile(nmFile, customPath);
      }
      return;
    }

    if (id == "btnDownload") {
      if (!focusedRowNode.data.nm_file) {
        await showDialog("alter", "첨부된 파일이 없습니다.");
        return;
      }
      fileHelperRef.current?.downloadFile(
        focusedRowNode.data.nm_file,
        customPath
      );
      return;
    }

    if (id == "btnDelete") {
      // 행 삭제 → grid3 db 저장 → 성공 시 서버 파일 삭제 순서
      if (!focusedRowNode.data.nm_file) {
        await showDialog("alter", "첨부된 파일이 없습니다.");
        return;
      }
      const nmFile = focusedRowNode.data.nm_file;
      onDeleteRow();
      const ok = await saveGrid3Changes();
      if (!ok) return; // db 삭제 실패 시 파일은 남긴다 (행은 복구됨)
      await fileHelperRef.current?.deleteFile(nmFile, customPath);
      return;
    }

    if (id == "btnAttach") {
      let parentUnsaved = false;
      gridRefs.current["grid1"].current?.forEachFilteredNode((node: any) => {
        if (
          node.data?.cd_cust === focusedRowNode.data.cd_cust &&
          node.data?.state === "insert"
        ) {
          parentUnsaved = true;
        }
      });
      if (parentUnsaved) {
        await showDialog(
          "alter",
          "저장되지 않은 거래처입니다. 거래처를 먼저 저장하세요."
        );
        return;
      }

      pendingAttachRef.current = {
        node: focusedRowNode,
        prevFile: focusedRowNode.data.nm_file || "",
        customPath,
      };
      fileHelperRef.current?.openFileDialog(customPath);
      return;
    }
  };

  const handleFileUploadSuccess = async (
    fileName: string,
    isUpload: boolean
  ) => {
    if (!isUpload) return;

    const pending = pendingAttachRef.current;
    pendingAttachRef.current = null;

    const targetNode =
      pending?.node ?? gridRefs.current["grid3"].current?.focusedRowNode();
    if (!targetNode) {
      await showDialog("alter", "첨부파일 행을 선택하세요.");
      return;
    }

    gridRefs.current["grid3"].current?.setValueImmediately(
      targetNode,
      "nm_file",
      fileName
    );

    const changes = gridRefs.current["grid3"].current?.getChange();
    if (!changes || changes.modifiedRowcount == 0) {
      await showDialog(
        "error",
        "첨부 내용을 저장하지 못했습니다. 재조회 후 다시 시도해주세요."
      );
      return;
    }

    const ok = await saveGrid3Changes();
    if (ok && pending?.prevFile && pending.prevFile !== fileName) {
      await fileHelperRef.current?.deleteFile(
        pending.prevFile,
        pending.customPath
      );
    }
  };

  const saveGrid3Changes = async () => {
    const fileChanges = gridRefs.current["grid3"].current?.getChange();
    if (!fileChanges || fileChanges.modifiedRowcount == 0) return true;

    const ok = await fnSave("SN_MAS_BAS_REG_001_SAVE_01", {
      mas_custfile: fileChanges,
    });
    gridRefs.current["grid3"].current?.resetUpdate(!ok);
    return ok;
  };

  const onSave = async () => {
    try {
      gridRefs.current["grid1"].current?.stopEditing();
      gridRefs.current["grid2"].current?.stopEditing();
      gridRefs.current["grid3"].current?.stopEditing();

      const requiredValuesCheck =
        gridRefs.current["grid1"].current?.requiredValuesCheck();
      if (!requiredValuesCheck) {
        return false;
      }

      const requiredValuesCheck2 =
        gridRefs.current["grid2"].current?.requiredValuesCheck(); //금융 그리드
      if (!requiredValuesCheck2) {
        return false;
      }

      const mascustChanges = gridRefs.current["grid1"].current?.getChange();
      const mascustChanges2 = gridRefs.current["grid2"].current?.getChange();
      const mascustFileChanges = gridRefs.current["grid3"].current?.getChange();

      if (
        mascustChanges.modifiedRowcount == 0 &&
        mascustChanges2.modifiedRowcount == 0 &&
        mascustFileChanges.modifiedRowcount == 0
      ) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return false;
      }

      // 거래처코드 글자수 확인
      const insertList = [
        ...(mascustChanges.insert || []),
        ...(mascustChanges2.insert || []),
      ];
      const hasInvalidCust = insertList.some(
        (item) => item.cd_cust && item.cd_cust.length > 10
      );
      if (hasInvalidCust) {
        await showDialog("alter", "거래처코드가 10자리를 초과하였습니다.");
        return false;
      }

      // 거래처코드 중복체크
      const gridData: any[] = [];
      gridRefs.current["grid1"].current.forEachFilteredNode((node: any) => {
        gridData.push(node.data);
      });
      const List = new Set<string>();
      if (gridRefs.current["grid1"].current.getDisplayedRowCount() > 1) {
        for (let i = 0; i < gridData.length; i++) {
          const row = gridData[i];
          const cd_cust = row?.cd_cust?.trim();
          if (!cd_cust) continue;

          if (List.has(cd_cust)) {
            await showDialog(
              "error",
              `거래처코드가 중복되었습니다. \n\n거래처코드 : ${cd_cust}`
            );
            return false;
          }
          List.add(cd_cust);
        }
      }
      let cdCustString = "";
      for (const i of mascustChanges.insert) {
        cdCustString += i?.cd_cust + ",";
      }
      const result = await callApi("SN_MAS_BAS_REG_001_SAVE_01_dupCdCust", {
        cd_firm: userInfo.cd_firm,
        cdCustString: cdCustString,
      });
      const data = result.data;
      if (data && data.length > 0) {
        for (const d of data) {
          const duplicated = gridData.find((row) => row.cd_cust === d.cd_cust);
          if (duplicated) {
            await showDialog(
              "error",
              `이미 등록된 거래처코드입니다.\n\n거래처코드 : ${d.cd_cust}`
            );
            return false;
          }
        }
      }

      const iuList = [
        ...(mascustChanges.insert || []),
        ...(mascustChanges.update || []),
      ];

      // 법인(주민)번호 유효성 체크
      const validCheck2 = await validByNoCust(iuList);
      if (!validCheck2) return false;

      // 사업자번호 유효성 체크
      const validCheck3 = await validByNoBiz(iuList);
      if (!validCheck3) return false;

      const saveData = {
        mas_cust: mascustChanges,
        mas_cust2: mascustChanges2,
        mas_custfile: mascustFileChanges,
      };
      const ok = await fnSave("SN_MAS_BAS_REG_001_SAVE_01", saveData);
      if (!ok) {
        gridRefs.current["grid1"].current.resetUpdate(true);
        gridRefs.current["grid2"].current.resetUpdate(true);
        gridRefs.current["grid3"].current.resetUpdate(true);
        return false;
      }

      gridRefs.current["grid1"].current?.resetUpdate();
      gridRefs.current["grid2"].current?.resetUpdate();
      gridRefs.current["grid3"].current?.resetUpdate();
      return true;
    } catch (error: any) {
      gridRefs.current["grid1"].current.resetUpdate(true);
      gridRefs.current["grid2"].current.resetUpdate(true);
      gridRefs.current["grid3"].current.resetUpdate(true);
      return false;
    }
  };

  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event;
    setFocusedRowData(selectedRow);
  };

  const onFocusedRowChanged2 = useCallback(
    (focusedRowData: any | null) => {
      setFocusedRowData2(focusedRowData);
    },
    [focusedRowData2]
  );

  const onValueChanged = (event: ValueChangedEvent) => {
    const { colId, newValue, rowData, popupRow } = event;
    if (colId === "nm_cust") {
      if (!rowData?.nm_cust_sort) {
        return { nm_cust_sort: newValue };
      }
    }
    if (colId === "no_post" && popupRow) {
      return { dc_address: popupRow.dc_address };
    }
    return {}; //cd_user_amd: userInfo.cd_user
  };

  const onTabChanged = (tabIndex: any) => {
    setIsVisible(!isVisible);
    selectedTabPage.current = tabIndex;
  };

  const onBeforeAddRow1 = (): boolean | Record<string, any> => {
    try {
      const updateRow = {
        cd_firm: userInfo.cd_firm,
        cd_uer_reg: userInfo.cd_user,
        yn_use: "Y",
        fg_cust: "1",
        tp_cust: "",
        cd_grpcust1: "",
        tp_etax: "1",
        fg_bill: "1",
        fg_billproc: "1",
      };

      return updateRow;
    } catch (error: any) {
      return false;
    }
  };

  const onBeforeAddRow2 = (): boolean | Record<string, any> => {
    try {
      const updateRow = {
        cd_firm: userInfo.cd_firm,
        cd_uer_reg: userInfo.cd_user,
        yn_use: "Y",
        fg_cust: "5",
        tp_etax: "1",
        tp_tax: "0",
        fg_bill: "1",
        fg_billproc: "1",
        vat_proc: "1",
        fg_vatproc: "1",
        am_security_l: 0,
        am_security_c: 0,
        am_security_e: 0,
      };
      return updateRow;
    } catch (error: any) {
      return false;
    }
  };

  const onBeforeAddRow3 = (): boolean | Record<string, any> => {
    try {
      const focusedRowNode = gridRefs.current["grid1"].current.focusedRowNode();

      const maxNoLine =
        gridRefs.current["grid3"].current.getMaxValue("no_line");
      const updateRow = {
        cd_firm: userInfo.cd_firm,
        cd_user_reg: userInfo.cd_user,
        nm_user_reg: userInfo.nm_user,
        tp_file: "010",
        no_line: maxNoLine + 1,
        cd_cust: focusedRowNode.data?.cd_cust,
      };

      return updateRow;
    } catch (error: any) {
      return false;
    }
  };

  /**
   * 법인(주민)번호 유효성 체크
   * 1. 글자수 13자리
   * 2. 거래처구분이 개인(4)인 경우에만 주민등록번호 유효성 체크
   */
  async function validByNoCust(list: any[]): Promise<boolean> {
    for (const l of list) {
      if (!l.no_cust) continue;

      const noCust = String(l.no_cust).replace(/-/g, "");
      if (noCust && noCust.length != 13) {
        showDialog(
          "alter",
          `거래처 [${l.cd_cust}] 의 법인(주민)번호가 13자리가 아닙니다.`
        );
        return false;
      }

      if (l.fg_cust === "4") {
        // 개인
        if (!isResidentNoCheckDigitValid(noCust)) {
          const confirm = await showDialog(
            "confirm",
            `거래처 [${l.cd_cust}] 의 주민번호가 검증 규칙과 일치하지 않습니다.\n그대로 등록 하시겠습니까?\n\n주민번호: ${l.no_cust}`
          );
          if (!confirm) return false;
        }
      }
    }
    return true;
  }

  /**
   * 주민등록번호 체크디지트 검증(13자리 숫자 기준)
   * 앞 12자리에 가중치(2,3,4,5,6,7,8,9,2,3,4,5)를 곱해 합산, (11 - 합 % 11) % 10 이 마지막 자리와 같아야 한다.
   * 2020-10 이후 신규 발급분은 뒷자리가 임의번호라 이 규칙을 따르지 않을 수 있다.
   */
  function isResidentNoCheckDigitValid(digits: string): boolean {
    const weights = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];
    let sum = 0;
    for (let i = 0; i < 12; i++) {
      sum += Number(digits[i]) * weights[i];
    }
    return (11 - (sum % 11)) % 10 === Number(digits[12]);
  }

  /**
   * 사업자번호 유효성 체크
   * 1. 글자수 10자리
   * 2. 기존 데이터 중복체크
   * 3. 공공데이터포털의 사업자번호 상태확인 api
   */
  async function validByNoBiz(list: any[]): Promise<boolean> {
    let noBizList: string[] = [];

    // 글자수 체크
    for (const l of list) {
      if (!l.no_biz) continue;

      const noBiz = String(l.no_biz).replace(/-/g, "");
      if (noBiz.length != 10) {
        showDialog(
          "alter",
          `거래처 [${l.cd_cust}] 의 사업자번호가 10자리가 아닙니다.`
        );
        return false;
      }
      noBizList.push(noBiz);
    }

    try {
      if (noBizList.length > 0) {
        // 중복체크
        const result = await callApi("SN_MAS_BAS_REG_001_SAVE_01_dupNoBiz", {
          cd_firm: userInfo.cd_firm,
          noBizString: noBizList.join(","),
        });
        const data = result.data;
        if (data && data.length > 0) {
          const first = data[0];
          const confirm = await showDialog(
            "confirm",
            `해당 사업자번호로 이미 등록된 거래처가 존재합니다. 그대로 등록 하시겠습니까?\n\n거래처코드 : ${first.cd_cust} \n거래처명 : ${first.nm_cust}`
          );
          if (!confirm) return false;
        }

        // 상태확인
        const statusResult = await callApi("check-biz-status", {
          b_no: noBizList,
        });
        const statusData = statusResult.data;
        if (statusData && statusData.length > 0) {
          for (const item of statusData) {
            if (item.b_stt_cd === "") {
              const confirm = await showDialog(
                "confirm",
                `해당 사업자번호는 국세청에 등록되지 않은 번호입니다. 그대로 등록 하시겠습니까?\n\n사업자번호: ${item.b_no}`
              );
              if (!confirm) return false;
            }
            if (item.b_stt_cd === "02") {
              const confirm = await showDialog(
                "confirm",
                `해당 사업자번호의 납세상태는 [휴업]으로 조회됩니다. 그대로 등록하시겠습니까?\n\n사업자번호: ${item.b_no}`
              );
              if (!confirm) return false;
            }
            if (item.b_stt_cd === "03") {
              const confirm = await showDialog(
                "confirm",
                `해당 사업자번호의 납세상태는 [폐업]으로 조회됩니다. 그대로 등록하시겠습니까?\n\n사업자번호: ${item.b_no}`
              );
              if (!confirm) return false;
            }
          }
        }
      }
    } catch (error) {
      return false;
    }
    return true;
  }

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged,
          onBeforeAddRow: onBeforeAddRow1,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onFocusedRowChanged: onFocusedRowChanged2,
          onBeforeAddRow: onBeforeAddRow2,
        },
      },
      grid3: {
        columns: columns.grid3,
        dataSource: dataSources.grid3,
        events: {
          onBtnAddClick: onGrid3BtnClick,
          onBtnDeleteClick: onGrid3BtnClick,
          onBeforeAddRow: onBeforeAddRow3,
        },
      },

      sheet1: {
        columns: columns.sheet1,
        dataSource: dataSources.sheet1,
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="w-full flex h-full min-h-0 space-x-1.5">
        <SnResizeBar direction={"width"} id="panel1" orgSize="34.5%">
          <SnTab
            titles={["일반", "금융"]}
            width={"100%"}
            onTabChanged={onTabChanged}
            header={[
              <SnTabHeader
                body={[
                  <div className="relative flex space-x-2">
                    <SnButton
                      text={"계좌번호"}
                      onClick={() => {
                        onGrid2BtnClick("btnDeposit1");
                      }}
                    />
                  </div>,
                ]}
              />,
              <SnTabHeader
                body={[
                  <div className="relative flex space-x-2">
                    <SnButton
                      text={"계좌번호"}
                      onClick={() => {
                        onGrid2BtnClick("btnDeposit2");
                      }}
                    />
                  </div>,
                ]}
              />,
            ]}
            body={[
              <SnGrid
                ref={gridRefs.current["grid1"]}
                columnConfig={grids.grid1.columns}
                rowData={grids.grid1.dataSource}
                etcProps={{ rowSelection: "single" }}
                events={grids.grid1.events}
                filter={{
                  refs: [gridRefs.current["grid3"]],
                  columns: ["cd_cust"],
                }}
              />,
              <SnGrid
                ref={gridRefs.current["grid2"]}
                columnConfig={grids.grid2.columns}
                rowData={grids.grid2.dataSource}
                etcProps={{ rowSelection: "single" }}
                events={grids.grid2.events}
              />,
            ]}
          />
        </SnResizeBar>

        <SnResizeBar direction={"width"} id="panel2" orgSize="65.5%">
          {isVisible && (
            <SnTab
              titles={["기본정보", "첨부파일"]}
              width={"100%"}
              header={[
                <SnTabHeader
                  body={
                    <div>
                      {/*더존(AM10)연동 환경에서만 사원정보 가져오기를 노출한다. */}
                      {config?.MAS0001?.dc_ctrl === "AM10" && (
                        <SnButton
                          text="가져오기"
                          onClick={() => onGrid1BtnClick("btnImport")}
                        />
                      )}
                    </div>
                  }
                />,
                <SnTabHeader
                  onBtnAddClick={onGrid3BtnClick}
                  onBtnDeleteClick={onGrid3BtnClick}
                  body={
                    <div>
                      <SnButton
                        text={"파일다운"}
                        onClick={() => {
                          onGrid3BtnClick("btnDownload");
                        }}
                      />
                      <SnButton
                        text={"파일삭제"}
                        onClick={() => {
                          onGrid3BtnClick("btnDelete");
                        }}
                      />
                      <SnButton
                        text={"파일첨부"}
                        onClick={() => {
                          onGrid3BtnClick("btnAttach");
                        }}
                      />
                    </div>
                  }
                />,
              ]}
              body={[
                <SnForm
                  ref={sharedFormRef1}
                  data={focusedRowData}
                  controls={sharedForm1}
                  gridref={gridRefs.current["grid1"]}
                  events={{ onValueChanged }}
                />,
                <SnGrid
                  ref={gridRefs.current["grid3"]}
                  columnConfig={grids.grid3.columns}
                  rowData={grids.grid3.dataSource}
                  etcProps={{ rowSelection: "single" }}
                  events={grids.grid3.events}
                />,
              ]}
            />
          )}

          {!isVisible && (
            <SnTab
              titles={["기본정보"]}
              width={"100%"}
              header={[
                <SnTabHeader
                  body={
                    <div>
                      {/*더존(AM10)연동 환경에서만 사원정보 가져오기를 노출한다. */}
                      {config?.MAS0001?.dc_ctrl === "AM10" && (
                        <SnButton
                          text="가져오기"
                          onClick={() => onGrid1BtnClick("btnImport")}
                        />
                      )}
                    </div>
                  }
                />,
              ]}
              body={[
                <SnForm
                  ref={sharedFormRef2}
                  data={focusedRowData2}
                  controls={sharedForm2}
                  gridref={gridRefs.current["grid2"]}
                  events={{ onValueChanged }}
                />,
              ]}
            />
          )}
          <SnFileHelper
            ref={fileHelperRef}
            onFileUploadSuccess={handleFileUploadSuccess}
          />
        </SnResizeBar>
      </div>

      <div style={{ display: "none" }}>
        <SnGrid
          ref={gridRefs.current["sheet1"]}
          columnConfig={grids.sheet1.columns}
          rowData={grids.sheet1.dataSource}
        />
      </div>
    </div>
  );
});

export default SN_MAS_BAS_REG_001;
